import React from 'react'
import { useMedia } from 'sb-hooks'

import Title from 'components/_new/typography/deprecated/Title/Title'
import { Box } from 'components/_new/layout'
import Review, { ReviewType } from 'components/review/Review/Review'

import s from './Reviews.scss'


type ReviewsProps = {
  title: ReactIntlMessage
  list: ReviewType[]
}


const Reviews: React.FunctionComponent<ReviewsProps> = (props) => {
  const { title, list } = props

  const { isMobile } = useMedia()

  return Boolean(list.length) && (
    <Box
      className={s.reviewsList}
      pt={isMobile ? 32 : 40}
    >
      <Title
        message={title}
        align="center"
        uppercase
        html
      />
      {
        list.map((review) => (
          <Review
            key={review.id}
            review={review}
            withMicrodata
            dataTestId="review"
          />
        ))
      }
    </Box>
  )
}


export default Reviews
